/**
 * Feedbacks API Client
 *
 * API client for user feedback submissions
 */

import { apiClient } from './client';

export interface CreateFeedbackRequest {
  text: string;
}

export interface CreateFeedbackResponse {
  feedbackId: string;
}

export const feedbacksApi = {
  /**
   * Submit user feedback
   * Endpoint: POST /feedbacks
   */
  create: async (data: CreateFeedbackRequest): Promise<CreateFeedbackResponse> => {
    const response = await apiClient.post<CreateFeedbackResponse>('/feedbacks', data);
    return response.data;
  },
};
